import { isClassicRelativeDateTime } from 'cadenza/relative-date-time/is-classic-relative-date-time';
import type { RelativeDateTime } from 'cadenza/relative-date-time/relative-date-time';
import { getRelativeDateTimeLabel } from 'cadenza/relative-date-time/relative-date-time';
import type { RelativeDateTimeInterval } from 'cadenza/relative-date-time/relative-date-time-interval';
import { getRelativeDateTimeIntervalLabel } from 'cadenza/relative-date-time/relative-date-time-interval';

export function getRelativeDateTimeOrIntervalLabel (relativeDateTimeOrInterval: RelativeDateTime | RelativeDateTimeInterval) {
  if (isClassicRelativeDateTime(relativeDateTimeOrInterval)) {
    return getRelativeDateTimeLabel(relativeDateTimeOrInterval as RelativeDateTime);
  } else {
    return getRelativeDateTimeIntervalLabel(relativeDateTimeOrInterval as RelativeDateTimeInterval);
  }
}
